import { useState } from 'react';
import classNames from 'classnames';
import close from '../../assets/images/close.png';
import styles from './EditNameModal.module.css';
import { updateFundraiserApi } from "../../api/fundraisers";
import Button from '../Button.jsx';
import FormInput from "../form/FormInput";
import FormButton from "../form/FormButton";
import FormError from "../form/FormError";

const EditNameModal = (props) => {
    const [formData, setFormData] = useState({
        name: props.fundraiser.name
    });
    const initialErrorObject = {
        name: false
    };
    const [errorObject, setErrorObject] = useState(initialErrorObject);
    const inputsMessagesErrorObject = {
        name: 'Name must be at least 10 characters long',
    };
    const [editNameInProgress, setEditNameInProgress] = useState(false);

    const checkNameLength = () => {
		if(formData.name.length < 10){
			setErrorObject((prevState) => ({...prevState, name: inputsMessagesErrorObject.name}));
			return false;
		}
		return true;
	};

    const submit = async(event) => {
        event.preventDefault();
        setErrorObject(initialErrorObject);
        setEditNameInProgress(true);
        if(!checkNameLength()){
            setEditNameInProgress(false);
            return;
        }
        const editNameResponse = await updateFundraiserApi(props.fundraiser.id, 'name', formData.name);
        let body;
        try{
            body = await editNameResponse.json();
        }
        catch(e){}
        if(editNameResponse && editNameResponse.ok){
            props.updateFundraiserName(body.data.change_history_id, formData.name);
            props.close();
        }
        else{
            const error = body?.error ? body.error : 'Update fundraiser name failed';
            setErrorObject((prevState) => ({...prevState, apiError: error}));
        }
        setEditNameInProgress(false);
    };

    return (
        <div className={styles.modal}>
            <div className={styles.container}>
                <div className={styles.header}>
                    Edit name
                </div>
                <img className={styles.close} src={close} alt="Close" onClick={props.close}/>
                <form className={styles.form} onSubmit={submit}>
                    <FormInput className={styles.input} label="Fundraiser name" type="text" maxlength={120} placeholder="ie. HBS Class of 2005 20 Year Reunion"
                               value={formData.name} update={(event) => setFormData({...formData, name: event.target.value})} error={errorObject.name} required/>
                    {
                        errorObject.apiError && (
                            <FormError error={errorObject.apiError}/>
                        )
                    }
                    <div className={classNames(styles.buttons, {[styles.buttonsApiError]: errorObject.apiError})}>
                        <Button className={styles.button} text="Cancel" onClick={props.close}/>
                        <FormButton className={styles.button} style={{marginLeft: 'auto'}} text="Update" disabled={editNameInProgress}/>
                    </div>
                </form>
            </div>
        </div>
    )
};

export default EditNameModal;